module.exports = __webpack_public_path__ + "be790e17943a3badf8315c3b8e54e149.svg";